//types for auth
export const UPDATE_AUTH = "UPDATE_AUTH";

//types for user
export const UPDATE_USER_REDUCER = "UPDATE_USER";

//types for user detail
export const UPDATE_USER_DETAIL_REDUCER = "UPDATE_USER_DETAIL_REDUCER";

//types for user detail
export const UPDATE_CARS_TYPE_REDUCER = "UPDATE_CARS_TYPE_REDUCER";

//types for Discount 
export const UPDATE_DISCOUNTS_REDUCER = "UPDATE_DISCOUNTS_REDUCER";

//types for user detail
export const UPDATE_SERVICE_TYPE_REDUCER = "UPDATE_SERVICE_TYPE_REDUCER";

//types for service_pricing
export const UPDATE_SERVICE_PRICING_REDUCER = "UPDATE_SERVICE__PRICING_REDUCER";

//types for service_pricing
export const UPDATE_ORDER_REDUCER = "UPDATE_ORDER_REDUCER";

//types for service_pricing
export const CAR_COMPANY_REDUCER = "CAR_COMPANY_REDUCER";

//types for service_pricing
export const VEHICLE_REDUCER = "VEHICLE_REDUCER";

//types for testimonial
export const UPDATE_TESTIMONIAL_REDUCER = "UPDATE_TESTIMONIAL_REDUCER";

//types for coupon
export const UPDATE_COUPON_REDUCER = "UPDATE_COUPON_REDUCER";

//type for car lists
export const UPDATE_CAR_LIST_REDUCER = "UPDATE_CAR_LIST_REDUCER";

//types for logout
export const UPDATE_LOGOUT_REDUCER = "UPDATE_LOGOUT_REDUCER";
